import { render, staticRenderFns } from "./ConfigurationCreateAccessControl.vue?vue&type=template&id=c8ba6d12&scoped=true&"
import script from "./ConfigurationCreateAccessControl.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCreateAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba6d12",
  null
  
)

export default component.exports